import React from 'react'
import useSiteData from '../../useSiteData'
import { contentModelToBlock } from '../../util/contentModelToData'
import Benefits from '../organisms/Benefits'
import { markdownToJSX } from '../../util/transforms'
import Anchor from '../organisms/Anchor'


const Content = ({ titleAsH1, slug, title, intro, benefits, blocks, hasHero, translations }) =>
  <>
    <Anchor anchorName={ slug } alignBlock="center"/>
    <section className="u-container u-container--medium u-section-spacing u-section-spacing--narrow u-center-text">
      { hasHero && !titleAsH1 ? <h2 className={ 'a-heading-large' }>{ markdownToJSX(title) }</h2> :
        <h1>{ markdownToJSX(title) }</h1> }
      { intro && <p className="a-preamble">{ intro }</p> }
    </section>
    { benefits && <Benefits items={ benefits }/> }
    { blocks && blocks.map((block, index) => contentModelToBlock(block, index, { translations })) }
  </>

export default ({ pageContext }) => {
  const routeData = pageContext
  const { translations } = useSiteData().pageSettings
  const {  
    slugs, 
    subPage, 
    heroImage, 
    heroVideo
  } = routeData
    

  if (subPage) 
    return <Content titleAsH1={ true } hasHero={ (heroImage || heroVideo) ? true : false } translations={translations} { ...subPage } />
  else
    return <Content hasHero={ (heroImage || heroVideo) ? true : false } translations={translations} { ...routeData } />
};
